import { render, staticRenderFns } from "./CSSElements.vue?vue&type=template&id=54b376c0&scoped=true&"
import script from "./CSSElements.vue?vue&type=script&lang=js&"
export * from "./CSSElements.vue?vue&type=script&lang=js&"
import style0 from "./CSSElements.vue?vue&type=style&index=0&id=54b376c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b376c0",
  null
  
)

export default component.exports